import React from 'react';
import { View } from 'react-native';

import Text from '@/components/Typography/Text';
import Reveal from '@/components/Landing/Reveal';
import {
  Chip,
  Section,
  Split,
  useLanding,
} from '@/components/Landing/LandingKit';
import { fluid } from '@/components/Landing/landingTokens';
import {
  Band,
  Card,
  IconTile,
  Ordinal,
  SectionIntro,
} from '@/components/Landing/MarketingKit';
import { PROCESS } from '@/constants/enterpriseContent';

/**
 * The five stages, as a numbered column rather than five centred medallions.
 * A process is read in order, so it is set as a sequence you scan downward.
 */
function EnterpriseProcess() {
  const { band, isCompact, width } = useLanding();

  return (
    <Band glow="18% 30%">
      <Section label="How enterprise engagements run">
        <Split ratio={[1, 1.15]} align="flex-start">
          <View>
            <SectionIntro
              tone="band"
              kicker="How we work"
              lines={[['From idea'], ['to production.']]}
              lede="A methodology we run the same way every time, so you always know what happens next and what it produces."
              ledeMax={420}
            />

            <Reveal delay={140}>
              <Card tone="band" style={{ marginTop: fluid(width, 32, 44), gap: 16 }}>
                <IconTile name="bolt" size={40} tone="band" />
                <View>
                  <Text weight="bold" style={{ color: band.ink, fontSize: 17, letterSpacing: -0.3 }}>
                    Weeks, not quarters
                  </Text>
                  <Text style={{ color: band.muted, fontSize: 14, lineHeight: 22, marginTop: 6 }}>
                    Most engagements reach a working deployment inside a few weeks. Discovery
                    is a conversation, not a billable phase.
                  </Text>
                </View>
                <View style={{ flexDirection: 'row' }}>
                  <Chip tone="band" size="md" icon="check">Free consultation to start</Chip>
                </View>
              </Card>
            </Reveal>
          </View>

          <Reveal delay={100}>
            <View style={{ gap: 0, paddingTop: isCompact ? 0 : 6 }}>
              {PROCESS.map((step, index) => (
                <View
                  key={step.title}
                  style={{
                    flexDirection: 'row',
                    gap: 18,
                    paddingTop: index === 0 ? 0 : 24,
                    paddingBottom: index === PROCESS.length - 1 ? 0 : 24,
                    borderTopWidth: index === 0 ? 0 : 1,
                    borderColor: band.rule,
                  }}
                >
                  <Ordinal index={index} />
                  <View style={{ flex: 1, minWidth: 0 }}>
                    <Text weight="bold" style={{ color: band.ink, fontSize: 16.5, letterSpacing: -0.25 }}>
                      {step.title}
                    </Text>
                    <Text style={{ color: band.muted, fontSize: 14, lineHeight: 22, marginTop: 6 }}>
                      {step.copy}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </Reveal>
        </Split>
      </Section>
    </Band>
  );
}

export default React.memo(EnterpriseProcess);
